import React, { useRef, useState } from 'react'
import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { z } from 'zod'
import { Form, FormControl, FormField, FormItem, FormLabel } from '@/Components/ui/form'
import { Input } from '@/Components/ui/input'
import { Button } from '@/Components/ui/button'
import { useLoaderData, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import HeaderCard from '@/Components/HeaderCard'
import BodyCard from '@/Components/BodyCard'
import Loader from '@/Components/Common/Loader'
import SearchableDropdown from '@/Components/Common/SearchableDropdown'
import { Popover, PopoverContent, PopoverTrigger } from '@/Components/ui/popover'
import { format } from 'date-fns'
import { CalendarIcon } from 'lucide-react'
import { cn } from '@/lib/utils'
import { Calendar } from '@/Components/ui/calendar'
import { ScrollArea, ScrollBar } from '@/Components/ui/scroll-area'
import WorkAllocationService from '@/Service/WorkAllocationService'

const CreateWorkAllocation = () => {
    const { payorType, assessmentType } = useLoaderData()
    console.log('payorType', payorType, 'AssessmentType', assessmentType)

    const formRef = useRef(null)
    const [isSaving, setIsSaving] = useState(false)
    const formSchema = z.object({
        // client: z.string().min(1, {
        //     message: 'Client is required',
        // }),
        payor_type_hchb: z.string().min(1, {
            message: 'Payor type is required',
        }),
        assessment_type: z.string().min(1, {
            message: 'Assessment type group is required',
        }),
        time: z.date({
            required_error: 'Date is required',
            invalid_type_error: 'Invalid date',
        }),
        mr_number: z.string().min(1, {
            message: 'MR number is required',
        }),
        patient_name: z.string().min(1, {
            message: 'Patient name is required',
        }),
        production_tl: z.string().optional(),
        coder: z.string().optional(),
        priority: z.string().optional(),
    })

    const navigate = useNavigate()
    const form = useForm({
        shouldFocusError: false,
        resolver: zodResolver(formSchema),
        defaultValues: {
            assessment_type: '',
            payor_type_hchb: '',

            time: '',
            mr_number: '',
            patient_name: '',
            production_tl: '',
            coder: '',
            priority: '',
        },
    })

    async function onSubmit(values) {
        console.log('arrived date', form.getValues('time'))
        let time = form.getValues('time')
        const formatted = new Date(time).toLocaleString('sv-SE').replace('T', ' ')
        console.log('first,', formatted)
        // const formatted = new Date(form.getValues('arrived_date')).toISOString().replace('T', ' ').slice(0, 19)
        values['arrived_date'] = formatted

        try {
            setIsSaving(true)
            const resp = await WorkAllocationService.createWorkAllocation(values)
            if (resp.data.success) {
                console.log('resp', resp.data)
                setIsSaving(false)
                navigate(`/work-allocation`)
            }
        } catch (err) {
            console.log('err', err)
            setIsSaving(false)
        }
    }

    function onError(errors, e) {
        const errorKeys = Object.keys(errors)
        console.log('error', errors)
        if (errorKeys.length > 0 && errors[errorKeys[0]]?.message) {
            toast.error(errors[errorKeys[0]].message)
        } else {
            toast.error('Something went wrong.')
        }
    }

    const handleSaveClick = () => {
        if (formRef.current) {
            formRef.current.requestSubmit()
        }
    }

    function handleDateSelect(date) {
        if (date) {
            form.setValue('time', date)
        }
    }

    function handleTimeChange(type, value) {
        const currentDate = form.getValues('time') || new Date()
        let newDate = new Date(currentDate)

        if (type === 'hour') {
            const hour = parseInt(value, 10)
            newDate.setHours(newDate.getHours() >= 12 ? hour + 12 : hour)
        } else if (type === 'minute') {
            newDate.setMinutes(parseInt(value, 10))
        } else if (type === 'ampm') {
            const hours = newDate.getHours()
            if (value === 'AM' && hours >= 12) {
                newDate.setHours(hours - 12)
            } else if (value === 'PM' && hours < 12) {
                newDate.setHours(hours + 12)
            }
        }
        console.log("hours",newDate,currentDate,type)

        form.setValue('time', newDate)
    }
    return (
        <>
            <HeaderCard>
                <div className="flex justify-end items-center">
                    <div className="flex items-center justify-end gap-2">
                        <Button
                            className="bg-primary-purpal hover:bg-primary-purpal px-4"
                            onClick={handleSaveClick}
                            iconType="Save"
                            disabled={isSaving}
                        >
                            Save {isSaving && <Loader fullScreen={false} />}
                        </Button>
                    </div>
                </div>
            </HeaderCard>
            <BodyCard>
                <Form {...form}>
                    <form ref={formRef} onSubmit={form.handleSubmit(onSubmit, onError)} className="">
                        <div className="grid grid-cols-2 gap-y-3 gap-x-6">
                            {/* <FormField
                                control={form.control}
                                name="client"
                                render={({ field }) => (
                                    <FormItem className="space-y-1">
                                        <FormLabel required={true}>Agency</FormLabel>
                                        <FormControl>
                                            <SearchableDropdown
                                                options={[{ agency: 'Bayada' }]}
                                                placeholder="Agency"
                                                label="agency"
                                                selectedVal={field.value}
                                                handleChange={(val) => {
                                                    field.onChange(val)
                                                }}
                                            />
                                        </FormControl>
                                    </FormItem>
                                )}
                            /> */}

                            <FormField
                                control={form.control}
                                name="mr_number"
                                render={({ field }) => (
                                    <FormItem className="space-y-1">
                                        <FormLabel required={true}>MR Number</FormLabel>
                                        <FormControl>
                                            <Input
                                                className="shadow-none focus-visible:ring-transparent space-0 mt-0"
                                                placeholder="MR Number"
                                                {...field}
                                            />
                                        </FormControl>
                                    </FormItem>
                                )}
                            />

                            <FormField
                                control={form.control}
                                name="patient_name"
                                render={({ field }) => (
                                    <FormItem className="space-y-1">
                                        <FormLabel required={true}>Patient Name</FormLabel>
                                        <FormControl>
                                            <Input
                                                className="shadow-none focus-visible:ring-transparent space-0 mt-0"
                                                placeholder="Patient Name"
                                                {...field}
                                            />
                                        </FormControl>
                                    </FormItem>
                                )}
                            />
                            <FormField
                                control={form.control}
                                name="assessment_type"
                                render={({ field }) => (
                                    <FormItem className="space-y-1">
                                        <FormLabel required={true}>Assessment Type</FormLabel>
                                        <FormControl>
                                            <SearchableDropdown
                                                options={assessmentType}
                                                selectedVal={field.value}
                                                handleChange={(val) => field.onChange(val)}
                                                placeholder="Select Payor Type Group"
                                                label="assessment_type"
                                            />
                                        </FormControl>
                                    </FormItem>
                                )}
                            />

                            <FormField
                                control={form.control}
                                name="payor_type_hchb"
                                render={({ field }) => (
                                    <FormItem className="space-y-1">
                                        <FormLabel required={true}>Payor Type</FormLabel>
                                        <FormControl>
                                            <SearchableDropdown
                                                options={payorType}
                                                selectedVal={field.value}
                                                handleChange={(val) => field.onChange(val)}
                                                placeholder="Select Payor Type"
                                                label="payor_type"
                                            />
                                        </FormControl>
                                    </FormItem>
                                )}
                            />

                            <FormField
                                control={form.control}
                                name="time"
                                render={({ field }) => (
                                    <FormItem className="flex flex-col">
                                        <FormLabel required={true}>Arrived Date</FormLabel>
                                        <Popover>
                                            <PopoverTrigger asChild>
                                                <FormControl>
                                                    <Button
                                                        variant={'outline'}
                                                        className={cn('w-full pl-3 text-left font-normal', !field.value && 'text-muted-foreground')}
                                                    >
                                                        {field.value ? format(field.value, 'MM/dd/yyyy hh:mm aa') : <span>MM/DD/YYYY hh:mm aa</span>}
                                                        <CalendarIcon className="ml-auto h-4 w-4 opacity-50" />
                                                    </Button>
                                                </FormControl>
                                            </PopoverTrigger>
                                            <PopoverContent className="w-auto p-0">
                                                <div className="sm:flex">
                                                    <Calendar mode="single" selected={field.value} onSelect={handleDateSelect} initialFocus />
                                                    <div className="flex flex-col sm:flex-row sm:h-[300px] divide-y sm:divide-y-0 sm:divide-x">
                                                        <ScrollArea className="w-64 sm:w-auto">
                                                            <div className="flex sm:flex-col p-2">
                                                                {Array.from({ length: 12 }, (_, i) => i + 1)
                                                                    .reverse()
                                                                    .map((hour) => (
                                                                        <Button
                                                                            key={hour}
                                                                            size="icon"
                                                                            variant={
                                                                                field.value && field.value.getHours() % 12 === hour % 12
                                                                                    ? 'default'
                                                                                    : 'ghost'
                                                                            }
                                                                            className="sm:w-full shrink-0 aspect-square"
                                                                            onClick={() => handleTimeChange('hour', hour.toString())}
                                                                        >
                                                                            {hour}
                                                                        </Button>
                                                                    ))}
                                                            </div>
                                                            <ScrollBar orientation="horizontal" className="sm:hidden" />
                                                        </ScrollArea>
                                                        <ScrollArea className="w-64 sm:w-auto">
                                                            <div className="flex sm:flex-col p-2">
                                                                {Array.from({ length: 12 }, (_, i) => i * 5).map((minute) => (
                                                                    <Button
                                                                        key={minute}
                                                                        size="icon"
                                                                        variant={
                                                                            field.value && field.value.getMinutes() === minute ? 'default' : 'ghost'
                                                                        }
                                                                        className="sm:w-full shrink-0 aspect-square"
                                                                        onClick={() => handleTimeChange('minute', minute.toString())}
                                                                    >
                                                                        {minute.toString().padStart(2, '0')}
                                                                    </Button>
                                                                ))}
                                                            </div>
                                                            <ScrollBar orientation="horizontal" className="sm:hidden" />
                                                        </ScrollArea>
                                                        <ScrollArea className="">
                                                            <div className="flex sm:flex-col p-2">
                                                                {['AM', 'PM'].map((ampm) => (
                                                                    <Button
                                                                        key={ampm}
                                                                        size="icon"
                                                                        variant={
                                                                            field.value &&
                                                                            ((ampm === 'AM' && field.value.getHours() < 12) ||
                                                                                (ampm === 'PM' && field.value.getHours() >= 12))
                                                                                ? 'default'
                                                                                : 'ghost'
                                                                        }
                                                                        className="sm:w-full shrink-0 aspect-square"
                                                                        onClick={() => handleTimeChange('ampm', ampm)}
                                                                    >
                                                                        {ampm}
                                                                    </Button>
                                                                ))}
                                                            </div>
                                                        </ScrollArea>
                                                    </div>
                                                </div>
                                            </PopoverContent>
                                        </Popover>
                                    </FormItem>
                                )}
                            />
                            <FormField
                                control={form.control}
                                name="priority"
                                render={({ field }) => (
                                    <FormItem className="space-y-1">
                                        <FormLabel>Priority</FormLabel>
                                        <FormControl>
                                            <SearchableDropdown
                                                options={[
                                                    { priority: 'High', name: 'High' },
                                                    { priority: '', name: '' },
                                                ]}
                                                selectedVal={field.value}
                                                handleChange={(val) => field.onChange(val)}
                                                placeholder="Select Priority"
                                                label="priority"
                                            />
                                        </FormControl>
                                    </FormItem>
                                )}
                            />

                            <FormField
                                control={form.control}
                                name="coder"
                                render={({ field }) => (
                                    <FormItem className="space-y-1">
                                        <FormLabel>Coder</FormLabel>
                                        <FormControl>
                                            <SearchableDropdown
                                                options={[]}
                                                selectedVal={field.value}
                                                handleChange={(val) => field.onChange(val)}
                                                placeholder="Coder"
                                                label="coder"
                                            />
                                        </FormControl>
                                    </FormItem>
                                )}
                            />
                            <FormField
                                control={form.control}
                                name="prod_tl"
                                render={({ field }) => (
                                    <FormItem className="space-y-1">
                                        <FormLabel>Production TL</FormLabel>
                                        <FormControl>
                                            <SearchableDropdown
                                                options={[]}
                                                selectedVal={field.value}
                                                handleChange={(val) => field.onChange(val)}
                                                placeholder="Production TL"
                                                label="prod_tl"
                                            />
                                        </FormControl>
                                    </FormItem>
                                )}
                            />
                        </div>
                    </form>
                </Form>
            </BodyCard>
        </>
    )
}

export default CreateWorkAllocation
